import React from 'react';
import Slider from 'react-slick';
import { useSanityData } from '../hooks/useSanityData';
import { urlFor } from '../sanityClient';

// Fetches all performances from Sanity and renders the WePlay-style Slick carousel.
// Props come from the Sanity moduleShowSlider object (via ModuleRenderer).
export default function ShowSlider({ heading, slidesToShow = 5, autoplaySpeed = 1500, filterSection = '' }) {
  const lang = localStorage.getItem('language') || 'arm';

  const query = filterSection
    ? `*[_type == "performance" && navSection == $section] | order(year asc) { _id, title, slug, poster, year }`
    : `*[_type == "performance"] | order(year asc) { _id, title, slug, poster, year }`;

  const params = filterSection ? { section: filterSection } : {};
  const { data: performances, loading } = useSanityData(query, params);

  const slickerSettings = {
    customPaging: (i) => (i > 11 ? <div /> : <button>{i}</button>),
    infinite: true,
    centerPadding: '5px',
    slidesToShow,
    slidesToScroll: 1,
    speed: 500,
    centerMode: true,
    variableWidth: false,
    centerMargin: '0',
    adaptiveHeight: false,
    autoplay: true,
    dots: true,
    prevArrow: <div />,
    nextArrow: <div />,
    autoplaySpeed,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
          slidesToScroll: 0,
          adaptiveHeight: false,
          dots: true,
          prevArrow: <div />,
          nextArrow: <div />,
        },
      },
    ],
  };

  if (loading || !performances) return null;

  return (
    <section className='main-container main-container-decoration we-play-content we-play-container'>
      {heading && (
        <div className='description-banner'>
          <h2 className='title-generic'>{heading[lang] || heading.en}</h2>
        </div>
      )}
      <section className='center-slider m-auto we-dots'>
        <Slider {...slickerSettings}>
          {performances.map((p) => {
            const title = p.title ? (p.title[lang] || p.title.en || '') : '';
            const slug  = p.slug?.current || p.slug || '';
            const imgSrc = p.poster ? urlFor(p.poster).width(400).url() : '';
            return (
              <div className='slide' key={p._id}>
                <div className='slider-title'>
                  <h2>{title}</h2>
                  <p className='date text-center'>{p.year}</p>
                </div>
                <div className='child-element'>
                  <div className='deco1 animate animate__animated animate__bounce animate__fadeInDown'>
                    <img src='images/decoration1.svg' alt='icon' className='img-fluid' />
                  </div>
                  <a href={`/${slug}`}>
                    <img src={imgSrc} alt={title} className='img-fluid img-no-stretch' />
                  </a>
                  <div className='deco2 animate animate__animated animate__bounce animate__fadeInDown'>
                    <img src='images/decoration2.svg' alt='icon' className='img-fluid' />
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </section>
    </section>
  );
}
